<div
  class="ai-modal"
  [ngClass]="{ active: isOpen }"
  [style.transition-duration.ms]="config.animationDuration"
  (click)="onBackdropClick($event)"
>
  <div
    class="ai-modal-content"
    [style.transition-duration.ms]="config.animationDuration"
  >
    <ng-container
      *ngIf="config.iframeUrl && safeIframeUrl; else placeholderContent"
    >
      <iframe
        [src]="safeIframeUrl"
        frameborder="0"
        class="modal-iframe"
      ></iframe>
    </ng-container>
    <ng-template #placeholderContent>
      <div class="placeholder-text">here will be a chat</div>
    </ng-template>
  </div>
</div>
